<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem>人物管理 > <b>数字人训练</b></BreadcrumbItem>
      </Breadcrumb>
	  <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
		  <span class="search_span_width">
			  <span class="search_span_width_part1">ID：</span>
			  	<Input v-model="search.id" clearable style="width: 80px" />
			  </span>
		    <span class="search_span_width_part1">人物ID：</span>
		  		<Input v-model="search.figure_id" clearable style="width: 80px" />
		  	</span>
        <span class="search_span_width_part1">用户ID：</span>
          <Input v-model="search.user_id" clearable style="width: 80px" />
        </span>
	        <span class="search_span_width">
				<span class="search_span_width_part1">关键词：</span>
					<Input v-model="search.train_name" clearable style="width: 150px" />
				</span>
				<span class="search_span_width_part1">训练ID：</span>
					<Input v-model="search.inner_name" clearable style="width: 180px" />
				<span>
            <span class="search_span_width_part1">状态：</span>
	  			<Select v-model="search.status"  style="width:200px">
					<Option value="-1">未训练</Option>
					<Option value="1">训练中</Option>
					<Option value="2">训练成功</Option>
					<Option value="3">训练失败</Option>
					<Option value="4">驳回</Option>
					<Option value="5">已提交训练</Option>
					<Option value="8">DEMO确认</Option>
					<Option value="9">DEMO确认超时</Option>
					<Option value="11">DEMO已确认</Option>
					<Option value="20">待提交训练</Option>
            </Select>
        </span>
	    <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getFigureList(1)">搜索</Button>
	  </Card>
      <Card>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="train_list"></Table>
		   <Page :total="recordTotal" :current="page" :page-size="10" :show-elevator="true" @on-change="getFigureList"/>
        </Card>
      </Card>
    </Content>
	<Modal v-model="demo_video" title="DEMO"  :footer-hide=true>
	      <div v-for="url in demoVideos">
				<video ref="webm" controls="controls" preload="metadata" :src="url" v-show="url" width='40%' height="40%"></video>
	      </div>
	</Modal>
    <Modal v-model="showAllmodal" :footer-hide=true title="数字人训练信息"  @on-cancel = "onClose">
      <Form ref="figureAll" :model="figure_train" :label-width="100">
        <FormItem prop="figure_train_id" style="height: 0px;">
          <Input v-model="figure_train.id" v-show="false" />
        </FormItem>
        <FormItem label="demo文本内容" prop="demo_text">
          <textarea v-model="figure_train.demo_text" style="width: 90%;height: auto" />
        </FormItem>
        <FormItem label="demo音频内容" prop="demo_voice">
          <span  v-if ="figure_train.demo_type ===1">
                <!-- 音频播放器 -->
              <audio ref="audioPlayer" :id="'figure_voice_' + figure_train.id " :src="figure_train.demo_custom_voice" controls></audio>
             <Upload :action="getUploadUrl"  :headers="uploadHeader":data="uploadData" :on-success="successFigureVoice">
            <Button icon="ios-cloud-upload-outline">重新上传demo音频</Button>
          </Upload>
          </span>
          <span v-else-if ="figure_train.demo_type ===2">
            <span style="color: brown">{{this.figure_train.demo_content}}</span>
             <Upload :action="getUploadUrl"  :headers="uploadHeader":data="uploadData" :on-success="successFigureVoice">
            <Button icon="ios-cloud-upload-outline">上传demo音频</Button>
          </Upload>
          </span>
          <span v-else>
          <Upload :action="getUploadUrl" :headers="uploadHeader":data="uploadData" :on-success="successVoice">
            <Button icon="ios-cloud-upload-outline">上传demo音频</Button>
          </Upload>
          </span>
        </FormItem>
		<FormItem label="备注" prop="remark">
		  <textarea v-model="figure_train.remark" style="width: 90%;height: auto" />
		</FormItem>
        <FormItem>
          <Button type="primary" @click="doTrain()">提交训练</Button>
        </FormItem>
      </Form>
    </Modal>
  </Layout>
</template>
<script>
export default {
  data(){
    return {
      search : {
        id:0,
        figure_id:'',
        status:'',
        train_name :"",
        inner_name:"",
        user_id:""
      },
      demoVideos:[],
      figure_train:{
        demo_type:1, //默认值音频数据存在
        demo_content:"demo生成成功",
		remark:''
      },
      uploadData: {}, // 这里存放你想要附加的额外参数
      demo_video:false,
      showAllmodal:false,
      recordTotal:0,
      page:1,
      train_list:[],
		tableColumns:[
  	{ title: 'ID', key: 'id', align: 'center',width: 80 },
		{ title: '人物ID', key: 'figure_id', align: 'center',width: 80 },
		{ title: '用户ID', key: 'user_id', align: 'center',width: 80 },
        { title: '训练ID', key: 'inner_name', align: 'center',width: 180,
			render:(h,params) =>{
          if(params.row.inner_name){
            return h('span',{},'F'+params.row.inner_name);
          }

				return h('span',{},'');
			}
		},
		{ title: '人物名称', key: 'title', align: 'center' },
		{ title: '头像', key: 'cover', align: 'center',
		render:(h,params) =>{
		   return h('img',{
			// attrs : {src : params.row.thumb+'?x-oss-process=image/resize,p_3'},
             attrs : {src : params.row.cover},
			 style : { width : '80px', height : '80px' }
		   })
		}},
		{ title: '克隆类型', key: 'make_type', align: 'center',width: 80, render:(h,params) =>{
			  let status = '未知';
        if (params.row.make_type == '1') {
          status = '高品质';
        }else if (params.row.make_type == '2') {
          status = '标准版';
        }else if (params.row.make_type == '3') {
          status = '照片';
        } else if (params.row.make_type ==5) {

          if(params.row.ip_type=='1'){
            status = '极速版';
          }
          if(params.row.ip_type=='4'){
            status = '灵动';
          }
        }else if (params.row.make_type == '4') {
          status = '4K';
        }
			  return h('span',{},status);
		  }
     },
		{ title: '训练抠图', key: 'matting', align: 'center',width: 80, render:(h,params) =>{
			 let status = '未知';
		    if (params.row.sub_type== 3) {
				status = '扣图';
			}else if (params.row.sub_type == 4) {
				status = '不扣图';
			}
			return h('span',{},status);
		 } },
        { title: '算力ID', key: 'train_task_id', align: 'center' },
		{ title: '信息', key: 'video', align: 'center',width: 130,
		 render: (h, params) => {
			   if (params.row.url == '') {
				   return '';
			   }
			let btns=[]
			
				if (params.row.video) {
					btns.push(h('Button', {
					  props: {type: 'info',size: 'small'},
					  on: {
						click: () => { 
							window.open(params.row.video)
						}
					  }
					}, 'MP4'));
				}
				if (params.row.photo) {
					btns.push(h('Button', {
					  props: {type: 'info',size: 'small'},
					  on: {
						click: () => { 
							window.open(params.row.photo)
						}
					  }
					}, 'PHOTO'));
				}
				if (params.row.webm !='') {
					btns.push(
						h('Button', {
						  props: {type: 'success',size: 'small'},
						  on: {
							click: () => { 
								window.open(params.row.webm)
							}
						  }
						}, 'WEBM'));
				}

				if (params.row.train_video !='') {
					btns.push(
						h('Button', {
						  props: {type: 'warning',size: 'small'},
						  on: {
							click: () => { 
								window.open(params.row.train_video);
							}
						  }
						}, '原始视频'));
				}
				if (params.row.authorization_file !='') {
					btns.push(
						h('Button', {
						  props: {type: 'primary',size: 'small'},
						  on: {
							click: () => { 
								window.open(params.row.authorization_file)
							}
						  }
						}, '授权'));
				}
				return h("div",btns);
		 }},
		{ title: '训练状态', key: 'status', align: 'center', render:(h,params) =>{
			 let status = '未训练';
		    if (params.row.status == '1') {
				status = '训练中';
			}else if (params.row.status == '2') {
				status = '训练结束';
			}else if (params.row.status == '3') {
				status = '训练失败';
			}else if (params.row.status == '4') {
				status = '驳回';
			}else if (params.row.status == '5') {
				status = '已提交训练';
			}else if (params.row.status == '8') {
				status = 'DEMO确认';
			}else if (params.row.status == '10') {
				status = '已上架';
			}else if (params.row.status == '11') {
				status = '可上架';
			}else if (params.row.status == '12') {
				status = '已下架';
			}
			return h('span',{},status);
		 }},
		 /*{ title: '提交状态', key: 'submit_status', align: 'center', render:(h,params) =>{
			let submit_status = '待提交审核';
		    if (params.row.submit_status == '1') {
				submit_status = '审核中';
			}else if (params.row.submit_status == '2') {
				submit_status = '审核成功';
			}else if (params.row.submit_status == '3') {
				submit_status = '审核失败';
			}
			return h('span',{},submit_status);
		 }},*/
		 { title: '操作', key: 'action', align: 'center',width: 100,
		   render: (h, params) => {

		 	let btns=[]
			if (params.row.status == 0 || params.row.status == 4 || params.row.status == 3 || params.row.status==20) {
/*				btns.push(
					h('Button', {
					  props: { type: 'error', size: 'small' },
					  style: { marginRight: '5px', marginBottom: '5px'},
					  on: {
						click: () => {      
							this.$Modal.confirm({
								content: '<p>确定提交？</p>',
								cancelText: '取消',
								onOk: () => {
									this.http.post('/admin/figure/doTrain',{train_id:params.row.id}).then(response=>{
									  let data=response.data;
									  if(data.code!==0) {
									    this.$Message.error(data.message);
									    return false;
									  } else{
									    this.$Message.info(data.message);
										this.getFigureList(this.page);
									    return true;
									  }
									});
								},
								onCancel: () => {
									return true;
								}
							});	
						}
					  }
					}, '训练'),
				);*/
        btns.push(
            h('Button', {
              props: { type: 'error', size: 'small' },
              style: { marginRight: '5px', marginBottom: '5px'},
              on: {
                click: () => {
                  this.figure_train.id = params.row.id;
                  this.figure_train.demo_text = params.row.demo_text;
                  this.figure_train.demo_custom_voice = params.row.demo_custom_voice;
                  if(!this.figure_train.demo_custom_voice || this.figure_train.demo_custom_voice ===""){
                    this.figure_train.demo_type =3; //音频数据不存在
                    this.uploadData.figure_voice_id = params.row.id;
                    //请求数据查看合成数据
                    this.http.post('/admin/figure/getVoiceTrainInfo',{figure_train_id:params.row.id}).then(response=>{
                      let data=response.data;
                      if(data.code!==0) {
                        this.$Message.error(data.message);
                        return false;
                      } else{
                        if(Object.keys(data.data).length>0)
                        {
                          if(data.data.demo_voice_url ===""){
                            this.figure_train.demo_content = "音频生成中。。。";
                            if(data.data.status ==="FAILED")
                            {
                              this.figure_train.demo_content = "音频生成失败！";
                            }
                            this.figure_train.demo_type =2; //任务音频数据未生成
                          }else{
                            this.figure_train.demo_custom_voice = '';
                            this.figure_train.demo_type = 1;
                          }
                        }
                       // this.$Message.info(data.message);
                        return true;
                      }
                    });
                  }
                  this.showAllmodal = true;
                }
              }
            }, '训练'),
        );

				btns.push(
					h('Button', {
					  style: { marginRight: '5px', marginBottom: '5px'},
					  props: {type: 'error',size: 'small'},
					  on: {
						click: () => { 
							this.trainReject(params.row.id);
						}
					  }
				}, '驳回'));
				
				if (params.row.status == 3) {
					btns.push(
						h('Button', {
						  style: { marginRight: '5px', marginBottom: '5px'},
						  props: {type: 'error',size: 'small'},
						  on: {
							click: () => { 
								this.$Notice.open({
									title: '审核信息',
									desc: params.row.response,
									duration: 0
								});
							}
						  }
					}, '审核信息'));
				}
				if (params.row.status == 8) {
					btns.push(
						h('Button', {
						  style: { marginRight: '5px', marginBottom: '5px'},
						  props: {type: 'error',size: 'small'},
						  on: {
							click: () => { 
								this.demoVideos = params.row.demoVideos;
								this.demo_video = true;
							}
						  }
					}, '查看DEMO'));
				}
			}
		 	return h("div",btns);
		   }
		 }
		],
		uploadHeader:{
			"Authorization":localStorage.getItem('token'),
			"token":localStorage.getItem('token')
		},
	}
  },
  mounted:function(){
	this.getFigureList();
  },
  computed:{
	  getUploadUrl(){
	      return process.env.VUE_APP_APIHOST+'/admin/figure/upload';
	  }
  },
  methods:{
	getFigureList(page=this.page) {
		this.page = page;
		let p = {'page' : page}
		let params = Object.assign(this.search, p);
		this.http.get('/admin/figure/trainList',{params:params}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.train_list = data.data.list;
			this.recordTotal = data.data.total;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	makeAlpha(train_id){
		this.http.post('/admin/figure/makeAlpha',{train_id:train_id}).then(response=>{
		  let data=response.data;
		  if(data.code!==0) {
		    this.$Message.error(data.message);
		    return false;
		  } else{
		    this.$Message.info(data.message);
		    return true;
		  }
		});
	},
	trainReject(train_id){
		this.http.post('/admin/figure/doTrain',{train_id:train_id, status:-1}).then(response=>{
		  let data=response.data;
		  if(data.code!==0) {
		    this.$Message.error(data.message);
		    return false;
		  } else{
		    this.$Message.info(data.message);
		    return true;
		  }
		});
	},
    doTrain(){
      this.$Modal.confirm({
        content: '<p>确定提交？</p>',
        cancelText: '取消',
        onOk: () => {
          this.http.post('/admin/figure/doTrain',{
			  train_id:this.figure_train.id,
			  demo_text:this.figure_train.demo_text,
			  demo_custom_voice:this.figure_train.demo_custom_voice,
			  remark:this.figure_train.remark
			  }).then(response=>{
            let data=response.data;
            if(data.code!==0) {
              this.$Message.error(data.message);
              return false;
            } else{
              this.$Message.info(data.message);
              this.getFigureList(this.page);
              this.showAllmodal = false;
              return true;
            }
          });
        },
        onCancel: () => {
          return true;
        }
      });
    },
  successVoice(response, file, fileList){
    let data=response
    if(data.code !==0) {
      this.$Message.error(data.message);
      return true;
    }
    this.figure_train.demo_type = 1;
    this.figure_train.demo_custom_voice=data.data.url;
  },
  successFigureVoice(response){
    let data=response
    if(data.code !==0) {
      this.$Message.error(data.message);
      return true;
    }
    this.figure_train.demo_custom_voice=data.data.url;
    if(this.figure_train.demo_type ==2)
    {
      this.figure_train.demo_type = 1;
    }else{
      const id = "figure_voice_"+this.figure_train.id;
      // 获取页面中的audio元素
      var audioElement = document.getElementById(id);
      // 更新audio元素的src属性，使其指向新的音频URL
      audioElement.src = data.data.url;
    }

  },
    //关闭按钮
    onClose(){
      this.getFigureList(this.page);
      this.showAllmodal = false;
    },
	onCopy(url) {
	    navigator.clipboard.writeText(url).then(() => {
	        this.$Message.success('复制成功')
	    }).catch (err => {
	          this.$Message.error("复制失败");
	    })
	}
  }
}
</script>
